import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    sessionsGraphButton: {
      borderColor: palette.navCompanyContextActions,
      color: palette.navCompanyContextActions,
    },
    legendContainer: { marginBottom: 16, gap: '8px' },
    labelsModal: { display: 'flex', alignItems: 'center' },
    graphSessionsMax: { marginRight: 2, fontSize: 20, color: palette.yellow },
    graphVacanciesMax: {
      marginRight: 2,
      fontSize: 20,
      color: palette.digitalBlue,
    },
    graphLegendItem: {
      fontSize: 12,
      alignItems: 'center ',
      display: 'flex',
    },
    filterText: {
      fontWeight: 500,
      fontSize: 14,
      marginRight: 8,
    },
  });
